import { configureStore } from "@reduxjs/toolkit";
import UserInfoSlice from "./UserInfoSlice";
import WorkFlowSlice from "./Slice/WorkFlowRedux";
import WorkFlowTeamSlice from "./Slice/WorkflowTeamRedux";
import AuthFlowSlice from "./Slice/AuthFlowRedux";
import CategorySlice from "./Slice/CategoryRedux";
import MachineSlice from "./Slice/MachineRedux";
import RoleSlice from "./Slice/RoleRedux";
import MachineFaqSlice from "./Slice/MachineFaqRedux";
import ProjectTermSlice from "./Slice/ProjectTermRedux";
import SubscriberSlice from "./Slice/SubscribersRedux";
import UserSlice from "./Slice/UserRedux";
import CaseSlice from "./Slice/CaseRedux";
import CartSlice from "./Slice/CartRedux";
import SubscribersContactSlice from "./Slice/SubscribersContactRedux";
import IndustrySlice from "./Slice/IndustryRedux";
import AllLogSlice from "./Slice/AllLogRedux";
import LogoSlice from "./Slice/LogoRedux";
import OrderSlice from "./Slice/OrderRedux";
import InvoiceSlice from "./Slice/InvoiceRedux";
import UserMachineReviewSlice from "./Slice/UserMachineReviewRedux";
import DigiSignSlice from "./Slice/DigiSignRedux";
import BlogSlice from "./Slice/BlogRedux";
import NotificationSlice from "./Slice/NotificationRedux";
import SubscriptionSlice from "./Slice/SubscriptionsRedux";
import CostManagementSlice from "./Slice/CostManagementRedux";
import AIAPISlice from "./Slice/AIAPI";
import DatabaseSlice from "./Slice/DatabaseRedux";
import OAuthVaultSlice from "./Slice/OAuthVaultRedux";
import SandboxWorkFlowSlice from "./Slice/SandboxWorkFlowRedux";


const Store = configureStore({
    reducer: {
        oauthvault: OAuthVaultSlice,
        userinfo: UserInfoSlice,
        workflowredux: WorkFlowSlice,
        workflowteamredux: WorkFlowTeamSlice,
        authflowredux: AuthFlowSlice,
        categoryredux: CategorySlice,
        machineredux: MachineSlice,
        roleredux: RoleSlice,
        machinefaqredux: MachineFaqSlice,
        projecttermredux: ProjectTermSlice,
        subscriberredux: SubscriberSlice,
        userredux: UserSlice,
        subscriberscontactredux: SubscribersContactSlice,
        industryredux: IndustrySlice,
        alllogredux: AllLogSlice,
        logoredux: LogoSlice,
        caseredux: CaseSlice,
        cartredux: CartSlice,
        orderredux: OrderSlice,
        invoiceredux: InvoiceSlice,
        userMachineReviewredux: UserMachineReviewSlice,
        digisignredux: DigiSignSlice,
        blogredux: BlogSlice,
        notification: NotificationSlice,
        costmanagement: CostManagementSlice,
        aiapi: AIAPISlice,
        sunscriptionRedux: SubscriptionSlice,
        databaseredux: DatabaseSlice,
        sandboxworkflowredux: SandboxWorkFlowSlice,
    },
});

export default Store;
